@use '@lib/assets/styles/main.scss' as *;

.inputNumber {
  width: 112px;
}
